import { resolveFieldValueFromObject } from "@utils/common.js";
// import * as priceListaction from "./priceList/priceList.action";
// import * as priceGroupaction from "./priceGroup/priceGroup.action";
import * as externalServicesActions from "./externalServices.action";


const defaultState = {
  externalServices: [],
  subsExternalServices: [],
  externalServicesLoading: false,
  subsExternalServicesLoading: false,
  removingSubsExternalService: false,
  subsExternalServiceRemoved: false 
};

const externalServicesReducer = (state = defaultState, action) => {
  const { type, payload } = action;

  switch (type) {
  
    case externalServicesActions.CAMPAIGN_IS_LOADING_EXTERNAL_SERVICES: {
      return { ...state, externalServices: [], externalServicesLoading: true };
    }
    case externalServicesActions.CAMPAIGN_SET_ALL_EXTERNAL_SERVICES: {
      console.log({payload})
      return { ...state, externalServices: payload, externalServicesLoading: false };
    }

    case externalServicesActions.CAMPAIGN_SET_REMOVING_EXTERNAL_SERVICES: {
          return { ...state, removingExternalService: payload, externalServiceRemoved: false };
    }

    case externalServicesActions.CAMPAIGN_EXTERNAL_SERVICES_REMOVED: {
      return { ...state, removingExternalService: false, externalServiceRemoved: true };
    }

    //subs external services
    case externalServicesActions.EXTERNAL_SERVICES_IS_LOADING_SUBS_EXTERNAL_SERVICES: {
      return { ...state, subsExternalServices: [], subsExternalServicesLoading: true };
    }
    case externalServicesActions.EXTERNAL_SERVICES_SET_ALL_SUBS_EXTERNAL_SERVICES: {
      console.log({payload})
      return { ...state, subsExternalServices: payload, subsExternalServicesLoading: false };
    }

    case externalServicesActions.EXTERNAL_SERVICES_SET_REMOVING_EXTERNAL_SERVICES: {
      return { ...state, removingSubsExternalService: payload, subsExternalServiceRemoved: false };
    }

    case externalServicesActions.EXTERNAL_SERVICES_EXTERNAL_SERVICES_REMOVED: {
      return { ...state, removingSubsExternalService: false, subsExternalServiceRemoved: true };
    }
   
    default:
      return state;
  }
};

export default externalServicesReducer;
